// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';

const ClaimTitle = props =>
    <span>
        <FormattedMessage id='CLAIM'/>
        <span>
            {` ${formatClaimNumber(props.claimId)}`}
        </span>
    </span>;

ClaimTitle.displayName = 'ClaimTitle';
ClaimTitle.propTypes = {
    claimId: PropTypes.string.isRequired
};
export default ClaimTitle;



// WEBPACK FOOTER //
// ./src/product/details/components/claim-title.js